// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"fx-z","modalContent":"gx-z","header":"hx-z","close":"ix-z"};